

































import { Vue, Component } from 'vue-property-decorator'
import { Button } from 'mand-mobile'

@Component({ components: { [Button.name]: Button } })
export default class Record extends Vue {
  get isSuccess() {
    if (this.$route.query.result === 'SUCCESS') {
      return true
    } else {
      return false
    }
  }
  get score() {
    if (this.$route.query.result === 'SUCCESS') {
      return this.$route.query.score
    } else {
      return ''
    }
  }
  get message() {
    if (this.$route.query.result === 'IAM_FAILED') {
      return this.$t(`result.tokenExpired`)
    } else {
      return this.$route.query.message
    }
  }
  get returnUrl() {
    return this.$route.query.returnUrl
  }
  nextStep() {
    if (this.$route.query.fromName === 'saas') {
      return
    }
    window.location.href = `${this.returnUrl}`
  }
  goBack() {
    window.history.go(-3)
  }
  beforeDestroy() {
    window.removeEventListener('popstate', this.goBack, false)
  }
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, '', document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
  }
}
